var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwiftUi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0D47A1;}\r\n\t.st1{fill:#1565C0;}\r\n\t.st2{fill:#1E88E5;}\r\n\t.st3{fill:#29B6F6;}\r\n\t.st4{fill:#00E5FF;}\r\n\t.st5{fill:#18FFFF;}\r\n\t.st6{fill:#448AFF;}\r\n\t.st7{fill:#40C4FF;}\r\n\t.st8{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.2,70H50.8C44.8,70,40,65.2,40,59.2V30.8C40,24.8,44.8,20,50.8,20h28.5C85.2,20,90,24.8,90,30.8v28.5 C90,65.2,85.2,70,79.2,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,30.8C90,24.8,85.2,20,79.2,20H50.8C44.8,20,40,24.8,40,30.8v12.5c4.2,4.5,11.8,9.9,19,9.9 c9.5-0.1,23.6-3.8,31-11.8V30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90,30.8C90,24.8,85.2,20,79.2,20H50.8C44.8,20,40,24.8,40,30.8v12.2c4.2,4.9,10,6.7,19,6.8 c14.5,0.1,25.9-6.7,31-13.1V30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90,30.8C90,24.8,85.2,20,79.2,20H50.8C44.8,20,40,24.8,40,30.8v11.4c6.1,3.7,12.6,4.5,17.6,4.6 c14.6,0.1,27.7-7.3,32.4-15.8V30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.2,20H50.8C44.8,20,40,24.8,40,30.8v8.3c5.8,3.8,11.8,4.8,17.9,4.8c10,0,26-5.3,30.9-17.9 C87.1,22.4,83.5,20,79.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.2,20H50.8C44.8,20,40,24.8,40,30.8v5.1c6.6,4.4,14.6,6.4,24.7,4c12.4-3,19.5-9.6,22-16.9 C84.7,21.1,82.1,20,79.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.2,20h-9.4C44.8,20,40,24.8,40,30.8V44l0.1,0.1c5.9,8.3,20.5,13.7,30,4.9c5.6-6.9,2.3-18.3-1.8-22 C66.2,25.2,62.9,22.3,60.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.8,20h-10C44.8,20,40,24.8,40,30.8v13.5c7.1,5.5,18.1,7.7,25.8,0.6c5.6-6.9,2.3-18.3-1.8-22 C63.1,22,62,21,60.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.8,20C44.8,20,40,24.8,40,30.8v11c6.5,2.7,14.3,2.7,20.2-2.7c4.5-5.6,3.3-14.1,0.4-19.1H50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.8,20C44.8,20,40,24.8,40,30.8v6.6c4.8,0.5,9.8-0.6,13.9-4.4c2.9-3.7,3.4-8.6,2.6-13H50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.2,32.3c0,0,9.5,14.3,17.5,19.2c-3,1-9.6,4.9-21-2.1c2.9,4,8.1,12,20.7,11.2c4.4-0.2,7.1-1.6,9.6-2.6 c2.5-1,4.9-0.9,6.9,2.8c0.4-3.3,0.5-6.5-2.9-10c0,0,3.4-13-11.1-23.3c3,6,4.8,9.4,3.3,17.8C68.9,43.2,57,33.6,54.3,30.5 c1.9,3.5,7.5,11,9.5,13C60.3,41.1,49.2,32.3,49.2,32.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftUi);
export default __webpack_public_path__ + "static/media/Swift-UI.399dcbcb95bdc12cf9041cf6eb41c432.svg";
export { ForwardRef as ReactComponent };